import { Header } from "./sharedTypes";

export type ExecuteRequest = {
  method: string;
  serverId: number;
  requestHeader?: Array<Header>;
  endpoint?: string;
  parameters?: string;
  body?: string;
  responseJsonSchemaForValidation?: string;
  internalId?: string;
}

export type ExecuteResponse = {
  statusCode: number;
  responseBody: string;
  time: number;
  isValid?: boolean;
  validationErrorMessage?: string;
}

export type TransformExecuteResponse = {
  isError?: boolean;
  internalId?: string;
  isLoad?: boolean;
  isLoadTestrail?: boolean;
  testrailResult?: ResultEnum;
  result?: ResultEnum;
} & ExecuteResponse;

export enum ResultEnum {
  passed = "passed",
  failed = "failed",
  passedExecutionTime = "passedExecutionTime",
  serverError = "serverError",
  skipped = "skipped"
}